import { Card, CardContent, Typography } from "@material-ui/core";
import React from "react";

export function About(props) {
  const { data } = props;
  const aboutData = {
    name: data.name,
    description: data.longDescription,
  };
  return (
    <Card>
      <CardContent>
        <Typography gutterBottom variant="h5">
          {aboutData.name}
        </Typography>
        <Typography variant="body1">
          {aboutData.description && aboutData.description.length > 300
            ? aboutData.description.slice(0, 300) + "..."
            : aboutData.description}
        </Typography>
      </CardContent>
    </Card>
  );
}
